import {
  CreateLocationDocument,
  CreateLocationMutation,
  CreateLocationMutationVariables,
  GetLocationsDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useCreateLocation = () => {
  const [executeMutation] = useMutation(CreateLocationDocument, {
    extractorFn: (data: CreateLocationMutation) => data.locationsMutations.createLocationsLocation,
  })

  const createLocation = async (variables: CreateLocationMutationVariables) => {
    return executeMutation({
      variables,
      refetchQueries: [
        {
          query: GetLocationsDocument,
        },
      ],
    })
  }

  return {
    createLocation,
  }
}
